import React from "react";

import { MenuCardSkeleton } from "@/components/Shared/Skeletons";

const MenuItemLoadingSkeleton = () => {
  return <MenuCardSkeleton className="shadow-low rounded" />;
};

export default MenuItemLoadingSkeleton;
